module.exports = __webpack_public_path__ + "static/media/shopping.332e7c4c.jpg";